import React, { useState, useEffect } from "react";
import "./CloudNotifications.css";
import axios from "axios";
import Menu from "../../components/menu/Menu";
import moment from "moment";

const CloudNotifications = (props) => {
  const [notificationsList, setNotificationsList] = useState([]);
  const [isNotifPopOpen, setNotifPopOpen] = useState(false);
  const [notifOpenType, setNotifOpenType] = useState("");
  const [notifPopData, setNotifPopData] = useState({});
  const [isLoaded, setLoaded] = useState(false);
  const [isLoadedNotifications, setLoadedNotifications] = useState(false);
  const [isAppointment, setAppointment] = useState(false);

  useEffect(() => {
    props.actSidebar(true);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "notifications/getCloudNotifications", {})
      .then((res) => {
        setLoadedNotifications(true);
        if (res.data.responseData) {
          setNotificationsList(res.data.responseData);
          handleNotificationsToRead(res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    // eslint-disable-next-line
  }, []);

  const handleNotificationType = (not_type) => {
    if (not_type && not_type !== null && not_type !== undefined) {
      var path = "";
      if (not_type === "appointment") {
        path = " appointment_notification_icon";
      } else if (not_type === "education") {
        path = " education_notification_icon";
      } else if (not_type === "pain") {
        path = " pain_notification_icon";
      } else if (not_type === "virtual") {
        path = " virtual_notification_icon";
      } else if (not_type === "question") {
        path = " question_notification_icon";
      } else if (not_type === "daily_tasks") {
        path = " daily_tasks_notification_icon";
      }

      return path;
    }
  };

  const handleNotificationsToRead = (data) => {
    if (data && data !== undefined && data !== null) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "notifications/getCloudNotifications", {})
        .then((res) => {
          if (res.data.responseData) {
            //console.log("responseData", res.data.responseData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const openNotifDets = (notificationId, notifInx, notifType, subId) => {
    setAppointment(false);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "notifications/markAsRead", { notificationId })
      .then((res) => {
        if (res.data.responseCode === 200) {
          var notifList = [...notificationsList];
          notifList[notifInx].is_read = 1;
          setNotificationsList(notifList);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setNotifOpenType(notifType);
    if (
      notifType === "appointment" &&
      notificationsList[notifInx].title.indexOf("is") === -1
    ) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "appointments/getAppointmentInfo", {
          id: subId,
        })
        .then((res) => {
          if (res.data.responseCode === 200 && res.data.responseData) {
            setAppointment(true);
            res.data.responseData.scheduleTimeFormat = moment(
              res.data.responseData.scheduleDateTime
            ).format("LT");
            res.data.responseData.scheduleTimeFormat =
              res.data.responseData.scheduleTimeFormat.split(" ")[0];
            setNotifPopData(res.data.responseData);
            setLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 417) {
            setNotifPopData({
              title:
                notificationsList[notifInx].title.indexOf("is") > -1
                  ? notificationsList[notifInx].title
                  : "This notification has expired.",
            });
            setLoaded(true);
          }
        });
    } else {
      setNotifPopData({ title: notificationsList[notifInx].title });
      setLoaded(true);
    }

    if (!isNotifPopOpen) {
      setNotifPopOpen(true);
    }
  };

  const closeNotifDets = () => {
    setNotifPopOpen(false);
    setLoaded(false);
  };

  const notificationDateTime = (notifText) => {
    try {
      if (!notifText || typeof notifText !== "string" || !notifText.includes("is") || !notifText.includes("at")) {
        throw new Error("Invalid notification text format.");
      }

      const partsAfterIs = notifText.split("is");
      if (partsAfterIs.length < 2) throw new Error("Missing date and time after 'is'.");

      let alteredString = partsAfterIs[1].split("at");
      if (alteredString.length < 2) throw new Error("Missing 'at' keyword for time.");

      const datePart = alteredString[0].trim();
      const timePart = alteredString[1].trim();

      // Format and validate using moment
      const fullDateTime = moment(new Date(`${datePart} ${timePart}`));
      if (!fullDateTime.isValid()) throw new Error("Invalid date or time format.");

      const formattedTime = fullDateTime.format("HH:mm");

      const [month, day, year] = datePart.split("/").map(Number);
      const [hours, minutes] = formattedTime.split(":").map(Number);

      if ([month, day, year, hours, minutes].some(isNaN)) {
        throw new Error("Invalid date or time components.");
      }

      const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
      const alteredDate = moment(utcDate).format("L");
      const alteredTime = moment(utcDate).format("LT");

      const updatedNotifText =
        notifText.split("at")[0].split("is")[0] + "is " + alteredDate + " at " + alteredTime;

      return updatedNotifText;
    } catch (error) {
      console.error("Error parsing notification text:", error.message);
      return notifText || "Invalid notification text";
    }
  };


  return (
    <div>
      <Menu
        title="Notifications"
      //disableBell={true}
      />
      <div
        className="notifications_container"
        style={{ position: isLoadedNotifications && notificationsList.length === 0 ? "relative" : "static" }}
      >
        {isLoadedNotifications ? (
          <div className="notifications_scrollable_container" style={{ padding: '10px' }}>
            {notificationsList.length > 0 ? (
              notificationsList.map((notification, n) => (
                <React.Fragment key={n}>
                  {n === 0 ||
                    moment(notification.notification_time).format("l") !==
                    moment(
                      notificationsList[n > 0 ? n - 1 : 0].notification_time
                    ).format("l") ? (
                    <div className="msg_date_separator">
                      {moment(notification.notification_time).format("l")}
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className={
                      "notification_container" +
                      (notification.is_read === 1 ? " notif_is_read_hold" : "")
                    }
                    key={notification.id}
                    onClick={
                      () =>
                        //notification.is_read === 0 ?
                        openNotifDets(
                          notification.id,
                          n,
                          notification.notification_type,
                          notification.sub_id
                        )
                      //  : ""
                    }
                  >
                    <div
                      className={
                        "notification_avatar" +
                        (handleNotificationType(
                          notification.notification_type,
                          notification.activity
                        )
                          ? ` ${handleNotificationType(
                            notification.notification_type
                          )}`
                          : ``)
                      }
                    ></div>
                    <div className="notification_info">
                      <div className="notification_title">
                        {notification.title.indexOf("/") > -1 &&
                          notification.title.indexOf(":") > -1
                          ? notificationDateTime(notification.title)
                          : notification.title}
                      </div>
                      <div className="notification_time">
                        {moment(notification.notification_time).fromNow()}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))
            ) : (
              <div className="no_content_notice_contain">
                <div className="programs_no_results_img notif_no_res_img"></div>
                <div className="programs_no_res_main">
                  You have 0 notifications.
                </div>
                <div className="programs_no_res_elab">
                  You have not received any notifications yet.
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              flex: 1,
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="p_load"></div>
          </div>
        )}
      </div>
      {isNotifPopOpen && (
        <div className="dlt_wrapper">
          <div
            className="approval_close"
            onClick={() => closeNotifDets()}
          ></div>
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              {notifOpenType === "appointment" && isAppointment ? (
                <>
                  {isLoaded ? (
                    <>
                      <div className="ab_details">
                        <div className="ab_dets_immutable">
                          Appointment Details
                        </div>
                        <div className="ab_success_row">
                          <b>Patient:</b> {notifPopData.patient_name}
                          <br />
                          <br />
                          <div className="ab_success_icon ab_lside_icon"></div>
                          {moment(notifPopData.scheduleDateTime).format(
                            "LT"
                          )}{" "}
                          &#45;{" "}
                          {moment(notifPopData.scheduleDateTime)
                            .set({
                              minute:
                                notifPopData.scheduleTimeFormat.split(
                                  ":"
                                )[1] === "00"
                                  ? 30
                                  : /* : notifPopData.scheduleTimeFormat.split(":")[1] === "15"
                                  ? 30 */
                                  notifPopData.scheduleTimeFormat.split(
                                    ":"
                                  )[1] === "30"
                                    ? 60
                                    : /* : notifPopData.scheduleTimeFormat.split(":")[1] === "45"
                                  ? 60 */
                                    "",
                            })
                            .format("LT")}{" "}
                          &#x2022; 30 min
                        </div>
                        <div className="ab_success_row">
                          <div className="ab_success_icon ab_rside_icon"></div>
                          {moment(notifPopData.scheduleDateTime).format(
                            "dddd, MMMM Do, YYYY"
                          )}
                        </div>
                      </div>
                      {notifPopData.pain_scale_level > -1 && (
                        <>
                          <div className="ab_discussion_title">
                            Pain & Discomfort
                          </div>
                          <div className="notif_subtitle">
                            Level {notifPopData.pain_scale_level}
                            {notifPopData.pain_scale_level === 0
                              ? " - No Pain"
                              : notifPopData.pain_scale_level <= 2
                                ? " - Mild"
                                : notifPopData.pain_scale_level <= 4
                                  ? " - Moderate"
                                  : notifPopData.pain_scale_level <= 6
                                    ? " - Severe"
                                    : notifPopData.pain_scale_level <= 8
                                      ? " - Most Severe"
                                      : notifPopData.pain_scale_level <= 10
                                        ? " - Unbearable"
                                        : ""}
                          </div>
                          <div
                            className={
                              "notif_pain_icon " +
                              (notifPopData.pain_scale_level === 0
                                ? "notif_no_pain"
                                : notifPopData.pain_scale_level <= 2
                                  ? "notif_mild"
                                  : notifPopData.pain_scale_level <= 4
                                    ? "notif_moderate"
                                    : notifPopData.pain_scale_level <= 6
                                      ? "notif_severe"
                                      : notifPopData.pain_scale_level <= 8
                                        ? "notif_most_severe"
                                        : notifPopData.pain_scale_level <= 10
                                          ? "notif_unbearable"
                                          : "")
                            }
                          ></div>
                        </>
                      )}
                      {notifPopData.description && (
                        <>
                          <div className="ab_discussion_title">
                            What would you like to discuss?
                          </div>
                          <div className="notif_discussion_answer">
                            {notifPopData.description}
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <div className="p_load"></div>
                  )}
                </>
              ) : (
                <>
                  {isLoaded ? (
                    <>
                      {notifPopData.title.indexOf("/") > -1 &&
                        notifPopData.title.indexOf(":") > -1
                        ? notificationDateTime(notifPopData.title)
                        : notifPopData.title}
                    </>
                  ) : (
                    <div className="p_load"></div>
                  )}{" "}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CloudNotifications;
